import { cn } from "@/lib/class-control";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  // Generate page numbers (show max 4 pages)
  const pageNumbers = Array.from({ length: Math.min(totalPages, 4) }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-end gap-[13px]">
      {/* Previous Button */}
      <button
        onClick={handlePrevious}
        disabled={currentPage === 1}
        className={cn(
          "size-10 rounded-[20px] flex items-center justify-center transition-colors",
          currentPage === 1 ? "text-gray-500 cursor-not-allowed" : "text-white cursor-pointer hover:bg-white/10"
        )}
      >
        <ChevronLeft className="size-5" />
      </button>

      {/* Page Numbers */}
      {pageNumbers.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={cn(
            "size-10 rounded-[20px] text-sm transition-colors",
            currentPage === page
              ? "bg-[#7846FF] text-white"
              : "text-white hover:bg-white/10"
          )}
        >
          {page}
        </button>
      ))}

      {/* Next Button */}
      <button
        onClick={handleNext}
        disabled={currentPage === totalPages}
        className={cn(
          "size-10 rounded-[20px] flex items-center justify-center transition-colors",
          currentPage === totalPages ? "text-gray-500 cursor-not-allowed" : "text-white cursor-pointer hover:bg-white/10"
        )}
      >
        <ChevronRight className="size-5" />
      </button>
    </div>
  );
}
